



















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Keluhan extends Vue {
  @Prop() setKeluhan: string;
  keluhan = null;
  label = "";
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];

  @Watch("keluhan")
  changeKeluhan(v) {
    if (v == "") {
      this.label = "";
    } else {
      this.label = "Keluhan Utama";
    }
    this.$emit("keluhan", v);
  }
  @Watch("setKeluhan")
  changeSetKeluhan(v) {
    this.keluhan = v;
  }
}
